import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  radioGroup: {
    gap: '7px',
    paddingBottom: '15px',
  },
  cardMaterial: {
    padding: '0px 10px',
    width: '240px',
  },
  selected: {
    padding: '0px 10px',
    width: '240px',
    borderWidth: '.15em',
    borderColor: theme.palette.brightBlue,
    backgroundColor: theme.palette.background.default,
  },
  error: {
    padding: '0px 10px',
    width: '240px',
    borderWidth: '.10em',
    borderColor: theme.palette.error.light,
    color: theme.palette.error.light,
  },
}))

export default styles
